import * as React from 'react';
import { connect } from 'react-redux';
import { ILocation } from '../../../../api/locations';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { IAppState, Dispatch } from '../../../../common/state';
import { EHouseMaterial } from '../../../../json_query';
import { FOfferType } from '../../../../utils/category';
import { IMakeRequest } from '../../../../utils/request';
import { toggleHouseMaterial } from '../../../state/advanced/house_material';
import { InlineParam, Row } from '../markup';
import { renderPickBanner } from '../param_with_banner';

const fullList: Array<{ material: EHouseMaterial; title: string }> = [
  { title: 'Кирпичный', material: EHouseMaterial.Brick },
  { title: 'Деревянный', material: EHouseMaterial.Wood },
  { title: 'Монолитный', material: EHouseMaterial.Monolith },
  { title: 'Панельный', material: EHouseMaterial.Panel },
  { title: 'Блочный', material: EHouseMaterial.Block },
  { title: 'Кирпично-монолитный', material: EHouseMaterial.BrickMonolith },
  { title: 'Сталинский', material: EHouseMaterial.Stalin },
];

const flatNewList: Array<{ material: EHouseMaterial; title: string }> = [
  { title: 'Панельный', material: EHouseMaterial.Panel },
  { title: 'Кирпичный', material: EHouseMaterial.Brick },
  { title: 'Монолитный', material: EHouseMaterial.Monolith },
];

const suburbanList: Array<{ material: EHouseMaterial; title: string }> = [
  { title: 'Кирпичный', material: EHouseMaterial.Brick },
  { title: 'Деревянный', material: EHouseMaterial.Wood },
  { title: 'Монолитный', material: EHouseMaterial.Monolith },
  { title: 'Щитовой', material: EHouseMaterial.Shield },
  { title: 'Каркасный', material: EHouseMaterial.Wireframe },
  { title: 'Газобетонный блок', material: EHouseMaterial.AerocreteBlock },
  { title: 'Газосиликатный блок', material: EHouseMaterial.GasSilicateBlock },
  { title: 'Пенобетонный блок', material: EHouseMaterial.FoamConcreteBlock },
];

const getMaterialsList = (offerType: FOfferType) =>
  (offerType === FOfferType.FlatNew && flatNewList) ||
  ((offerType & FOfferType.Suburban & ~FOfferType.Land) !== 0 && suburbanList) ||
  fullList;

interface IButtonCheckboxProps {
  material: EHouseMaterial;
  title: string;
}

export interface IHouseMaterialsProps {
  materials: EHouseMaterial[];
  offerType: FOfferType;
  currentLocation: ILocation | 'moscow_mo' | 'spb_lo';
  makeRequest: IMakeRequest;
  onChanged(material: EHouseMaterial, value: boolean): void;
}

export const houseMaterial: React.StatelessComponent<IHouseMaterialsProps> = props => {
  const getButtonCheckbox = (buttonProps: IButtonCheckboxProps): React.ReactNode => (
    <InlineParam key={buttonProps.title}>
      <ButtonCheckbox
        onValueChange={value => props.onChanged(buttonProps.material, value)}
        value={isHouseMaterialExists(props.materials, buttonProps.material)}
      >
        {buttonProps.title}
      </ButtonCheckbox>
    </InlineParam>
  );

  const buttons = getMaterialsList(props.offerType);
  // tslint:disable-next-line:no-unnecessary-callback-wrapper
  const renderedButtons = buttons.map(buttonProps => getButtonCheckbox(buttonProps));

  return props.offerType === FOfferType.FlatNew ? (
    renderPickBanner('Тип дома', renderedButtons, props.currentLocation, props.makeRequest)
  ) : (
    <Row title="Тип дома">{renderedButtons}</Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    materials: (state.filters.jsonQuery.house_material && state.filters.jsonQuery.house_material.value) || [],
    currentLocation: state.filters.currentLocation,
    makeRequest: state.makeRequest,
  }),
  (dispatch: Dispatch) => ({
    onChanged: (material: EHouseMaterial, value: boolean) => {
      dispatch(toggleHouseMaterial(material, value));
    },
  }),
  (stateProps, dispatchProps, ownProps: { offerType: FOfferType }) =>
    ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
    } as IHouseMaterialsProps),
)(houseMaterial);

function isHouseMaterialExists(materials: EHouseMaterial[], material: EHouseMaterial): boolean {
  return materials.indexOf(material) > -1;
}
